module.exports = __webpack_public_path__ + "img/sale2.be4de963.png";